module.exports = __webpack_public_path__ + "img/android.4adc14d6.png";